import LearnOnTheGo from '@comp/LearnOnTheGo/LearnOnTheGo';
import { HOME_PAGE } from '@constants/appFlyerLinks';

const SecondSlide = () => <LearnOnTheGo learnerAppOneLink={HOME_PAGE} />;

export default SecondSlide;
